// (function () {
//   const PROXY_URL = "https://digidrub.in/abcd/erp-proxy-ue.php"; 

//   async function fetchAndSync(sku, variant_id, product_id) {
//     try {
//       const res = await fetch(PROXY_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ sku, variant_id, product_id }),
//       });
//       const data = await res.json();
//       if (data.success) {
//         applyStockToPage(data.erp);
//       }
//     } catch (e) {
//       console.warn("ERP sync error:", e);
//     }
//   }

//   function applyStockToPage(item) {
//     if (!item) return;

//     const qtyEl = document.querySelector(".erp-stock-qty");
//     if (qtyEl) qtyEl.textContent = item.instockQty > 0 ? `${item.instockQty} available` : "Out of stock";

//     const atcBtn = document.querySelector('[name="add"], #AddToCart');
//     if (atcBtn && item.allowOutOfStockSales === "deny" && item.instockQty <= 0) {
//       atcBtn.disabled = true;
//       atcBtn.textContent = "Out of Stock";
//     }

//     const etaEngEl = document.querySelector(".erp-eta-eng");
//     if (etaEngEl) etaEngEl.textContent = item.etaEng && item.etaEng !== "0" ? `Ships in ${item.etaEng} days` : "";

//     const etaArbEl = document.querySelector(".erp-eta-arb");
//     if (etaArbEl) etaArbEl.textContent = item.etaArb && item.etaArb !== "0" ? item.etaArb : "";
//   }

//   function init() {
//     const el = document.getElementById("erp-stock-data");
//     if (!el) return;

//     const sku        = el.dataset.sku;
//     const variant_id = el.dataset.variantId;
//     const product_id = el.dataset.productId;

//     if (!sku || !variant_id || !product_id) {
//       console.warn("ERP: Missing sku, variant_id or product_id");
//       return;
//     }

//     fetchAndSync(sku, variant_id, product_id);
//   }

//   // Re-sync on variant switch
//   document.addEventListener("variant:change", (e) => {
//     const v = e.detail?.variant;
//     if (!v) return;
//     const el = document.getElementById("erp-stock-data");
//     const product_id = el?.dataset.productId;
//     fetchAndSync(v.sku, v.id, product_id);
//   });

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }

//   setTimeout(function() {
//     if (!sessionStorage.getItem('erp_reloaded')) {
//         sessionStorage.setItem('erp_reloaded', 'true');
//         location.reload();
//     }
// }, 3000);
//   setTimeout(function() {
//     if (!sessionStorage.getItem('erp_reloaded')) {
//         sessionStorage.setItem('erp_reloaded', 'true');
//         location.reload();
//     }
// }, 3000);

// })();

/**
 * erp-stock.js — live stock / ETA from the ERP, overriding the Shopify metafields
 * rendered into the page at build time.
 *
 * WHAT WAS WRONG
 *
 * 1. querySelector(".erp-stock-qty") returned the FIRST match, which is the
 *    hidden <p class="erp-stock-qty">Checking availability...</p>. The visible
 *    number lives in <span id="mydiv" class="erp-stock-qty">. So the live value
 *    was written into an invisible element and the page kept showing the stale
 *    metafield value. Same for .erp-eta-eng / .erp-eta-arb, both display:none,
 *    while the visible ETA is in .delivery-time h5.
 *    -> now uses querySelectorAll and also updates the visible elements.
 *
 * 2. backorderLimit was never read. A pre-order item has instockQty 0, and the
 *    number that matters is backorderLimit (5 in the API response). The old code
 *    would have shown "Out of stock" for a perfectly orderable pre-order item.
 *
 * 3. etaEng is already a full sentence ("This item will be available for delivery
 *    after 95 days"). Wrapping it as `Ships in ${etaEng} days` produced
 *    "Ships in This item will be available for delivery after 95 days days".
 *
 * 4. Two identical setTimeout blocks reloaded the whole page 3s after load. That
 *    was masking bug 1 rather than fixing it, cost every visitor a second page
 *    load, and broke the back button. Removed.
 */

(function () {
  const PROXY_URL = "https://digidrub.in/abcd/erp-proxy-ue.php";

  // ---------------------------------------------------------------- helpers

  const isArabic = (document.documentElement.lang || "").toLowerCase().startsWith("ar");

  // ETA fields arrive as a full sentence, but have historically also arrived as
  // a bare number or "0". Handle all three rather than assuming.
  function etaText(raw) {
    if (raw === null || raw === undefined) return "";
    const s = String(raw).trim();
    if (s === "" || s === "0") return "";
    if (/^\d+$/.test(s)) {
      return isArabic
        ? `سيكون هذا العنصر متاحاً للتسليم بعد ${s} يوماً`
        : `This item will be available for delivery after ${s} days`;
    }
    return s;   // already a sentence
  }

  function setAll(selector, value) {
    document.querySelectorAll(selector).forEach((el) => {
      el.textContent = value;
    });
  }

  // ---------------------------------------------------------------- fetch

  async function fetchAndSync(sku, variant_id, product_id) {
    if (!sku) return;
    try {
      const res = await fetch(PROXY_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sku, variant_id, product_id }),
      });

      // A non-200 used to fall through to res.json() and throw an opaque parse
      // error, hiding the real status.
      if (!res.ok) {
        console.warn("ERP proxy HTTP " + res.status + " for sku " + sku);
        return;
      }

      const data = await res.json();

      // The proxy may return the item directly or nested under .erp / .items[0].
      const item = data.erp || (data.items && data.items[0]) || data.item || null;

      if (!data.success || !item) {
        console.warn("ERP: no item returned for sku " + sku, data);
        return;
      }

      applyStockToPage(item);
    } catch (e) {
      console.warn("ERP sync error:", e);
    }
  }

  // ---------------------------------------------------------------- apply

  function applyStockToPage(item) {
    if (!item) return;

    const inStock    = parseInt(item.instockQty, 10) || 0;
    const backorder  = Math.abs(parseInt(item.backorderLimit, 10) || 0);
    const isPreOrder = String(item.allowOutOfStockSales || "").toLowerCase() === "continue";

    // For a pre-order item the sellable figure is the backorder allowance, not
    // instockQty (which is 0 by definition).
    const sellable = isPreOrder && inStock <= 0 ? backorder : inStock;

    // ---- quantity: every element carrying the class, not just the first ----
    setAll(".erp-stock-qty", String(sellable));

    // ---- label: "Pre-order Stock" vs "Available Stock" -------------------
    const stockWrap = document.getElementById("stock");
    if (stockWrap) {
      stockWrap.dataset.stocky = String(sellable);
      const label = isPreOrder
        ? (isArabic ? "مخزون الطلب المسبق:" : "Pre-order Stock:")
        : (isArabic ? "المخزون المتاح:" : "Available Stock:");
      // Replace only the leading text node so the <span id="mydiv"> is untouched.
      const first = stockWrap.firstChild;
      if (first && first.nodeType === Node.TEXT_NODE) {
        first.nodeValue = " " + label + " ";
      }
    }

    // ---- keep the +/- controls in step with the live numbers -------------
    const qtyInput = document.getElementById("product-qty");
    if (qtyInput) {
      qtyInput.dataset.stock = String(sellable);
      qtyInput.dataset.continueSelling = isPreOrder ? "true" : "false";
    }

    // ---- buy button ------------------------------------------------------
    const atcBtn = document.querySelector(".add-to-cart-btn, [name='add'], #AddToCart");
    if (atcBtn) {
      // Unsellable when there is genuinely nothing left: either backorders are
      // denied and stock is 0, or it is a pre-order whose allowance is used up.
      const soldOut = (!isPreOrder && inStock <= 0) || (isPreOrder && backorder <= 0);
      if (soldOut) {
        atcBtn.disabled = true;
        atcBtn.classList.add("sold-out");
        atcBtn.textContent = isArabic ? "نفذ" : "Sold Out";
      } else if (isPreOrder && inStock <= 0) {
        atcBtn.textContent = isArabic ? "أطلب مسبقاً" : "Pre-order";
      } else {
        atcBtn.textContent = isArabic ? "أضف المنتج إلى السلة" : "Add Item to Cart";
      }
    }

    // ---- ETA -------------------------------------------------------------
    const eng = etaText(item.etaEng);
    const arb = etaText(item.etaArb);

    setAll(".erp-eta-eng", eng);
    setAll(".erp-eta-arb", arb);

    // The visible ETA is rendered from the Shopify metafield inside
    // .delivery-time h5. Overwrite it, or the page keeps showing the stale
    // build-time value (70 days) while the ERP says something else (95 days).
    const visibleEta = document.querySelector(".delivery-time h5");
    if (visibleEta) {
      const text = isArabic ? (arb || eng) : (eng || arb);
      if (text) {
        visibleEta.textContent = text;
        const wrap = document.querySelector(".delivery-options");
        if (wrap) wrap.style.display = "";
      } else {
        const wrap = document.querySelector(".delivery-options");
        if (wrap) wrap.style.display = "none";   // no ETA -> hide the block
      }
    }

    document.dispatchEvent(new CustomEvent("erp:updated", { detail: item }));
  }

  // ---------------------------------------------------------------- init

  function currentIds() {
    const el = document.getElementById("erp-stock-data");
    if (!el) return null;
    return {
      sku: el.dataset.sku,
      variant_id: el.dataset.variantId,
      product_id: el.dataset.productId,
    };
  }

  function init() {
    const ids = currentIds();
    if (!ids) return;
    if (!ids.sku || !ids.variant_id || !ids.product_id) {
      console.warn("ERP: missing sku, variant_id or product_id on #erp-stock-data");
      return;
    }
    fetchAndSync(ids.sku, ids.variant_id, ids.product_id);
  }

  // Re-sync on variant switch.
  // The theme's own picker is radio inputs handled by updateSelectedPrice(); it
  // does not emit "variant:change", so that listener alone never fired. The
  // hidden #selected-variant-id field is what actually changes, so watch it.
  document.addEventListener("variant:change", (e) => {
    const v = e.detail && e.detail.variant;
    const ids = currentIds();
    if (!v || !ids) return;
    fetchAndSync(v.sku, v.id, ids.product_id);
  });

  function watchVariantField() {
    const field = document.getElementById("selected-variant-id");
    const ids = currentIds();
    if (!field || !ids) return;

    let last = field.value;
    const obs = new MutationObserver(() => {
      if (field.value === last) return;
      last = field.value;
      // The SKU belongs to the newly selected variant. window.productVariants is
      // set by the theme; fall back to the original SKU if it is unavailable.
      let sku = ids.sku;
      const list = window.productVariants || [];
      const match = list.find((x) => String(x.id) === String(field.value));
      if (match && match.sku) sku = match.sku;
      fetchAndSync(sku, field.value, ids.product_id);
    });
    obs.observe(field, { attributes: true, attributeFilter: ["value"] });

    // Attribute changes do not fire when the value is set via JS assignment, so
    // also poll lightly as a safety net.
    setInterval(() => {
      if (field.value !== last) {
        last = field.value;
        let sku = ids.sku;
        const list = window.productVariants || [];
        const match = list.find((x) => String(x.id) === String(field.value));
        if (match && match.sku) sku = match.sku;
        fetchAndSync(sku, field.value, ids.product_id);
      }
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
      watchVariantField();
    });
  } else {
    init();
    watchVariantField();
  }

  // NOTE: the two identical setTimeout blocks that called location.reload() after
  // 3 seconds have been removed. They were a workaround for bug 1 above -- the
  // page was reloaded in the hope the metafields would be fresher. They cost
  // every visitor a second page load, broke the back button, and did not fix the
  // underlying problem.
})();